function includes<T>(c: T, b: T[], prop: string): boolean {
    for (const ib of b) {
        if (ib[prop] === c[prop]) {
            return true;
        }
    }

    return false;
}

export default function differenceBy<T>(
    array1: T[],
    array2: T[],
    prop: string
): T[] {
    return [array1, array2].reduce((a: T[], b: T[]) =>
        a.filter(c => !includes<T>(c, b, prop))
    );
}
